import React from 'react';
import '../style.css';
import ScrollToTop from '../ScrollToTop';
import Footer from '../Footer';
import Navbar from '../Navbar';
import TopHeader from '../TopHeader';

const About = () => {

  return (

    <>
   <TopHeader/> 
    <Navbar/>
    <div className="aboutus-container">
    
      <h1 className="aboutus-title">About Us</h1>

      <section className="aboutus-section">
        <h2 className="aboutus-heading">Who We Are</h2>
        <p className="aboutus-text">
          Trip and Drop Travels Pvt. Ltd. is a registered travel company in New Delhi committed to delivering reliable, cost-effective, and professional travel services. We specialize in visa support, air tickets, international and domestic tour packages, and passport services.
        </p>
      </section>

      <section className="aboutus-section">
        <h2 className="aboutus-heading">Our Mission</h2>
        <p className="aboutus-text">
          To make travel planning easy, honest, and enjoyable. Whether it’s your first international trip or your hundredth, we ensure it’s memorable and hassle-free.
        </p>
      </section>

      <section className="aboutus-section">
        <h2 className="aboutus-heading">What Sets Us Apart</h2>
        <ul className="aboutus-list">
          <li>Personalized service and flexible tour options</li>
          <li>Affordable travel without compromising on quality</li>
          <li>Strong ties with embassies, airlines, and global travel partners</li>
        </ul>
      </section>

      <section className="aboutus-section">
        <h2 className="aboutus-heading">Company Details</h2>
        <ul className="aboutus-details">
          <li><strong>Legal Name:</strong> Trip and Drop Travels Private Limited</li>
          <li><strong>CIN No.:</strong> U79120DL2025PTC448107</li>
          <li><strong>Registered Address:</strong> H-35, Sant Nagar Extension, Tilak Nagar, New Delhi – 110018</li>
          <li><strong>Phone:</strong> +91 9999116868</li>
          <li><strong>Email:</strong> info@tripanddrop.com</li>
        </ul>
      </section>
    </div>

    <ScrollToTop/>
    <Footer/>
    </>
  );
};

export default About;
